module.exports = __webpack_public_path__ + "assets/img/202111-4.9c37100a.png";